import {ParallaxProvider, Parallax } from "react-scroll-parallax"
import  "./banner.scss"

export default function Banner() {
  return(
    <ParallaxProvider>
      <div className="banner_wrapper" id="home">
        <Parallax speed={-30}>
          {/* <div className="paralex_bg"/> */}
          <video className="paralex_bg" muted loop autoPlay playsInline>
            <source src="https://deuscharters.com/videos/banner.mp4" type="video/mp4"/>
          </video>
        </Parallax>
        <div className="container">
          <h1>DeuS Ex Machina</h1>
          <h2>Luxury Yacht Charter</h2>
        </div>
      </div>
    </ParallaxProvider>
  )
}